export default __webpack_public_path__ + "static/media/Anti-Money_Laundering.b630fb32.png";